<modal-hoc
    [modalTitle]="title"
    [modalTheme]="modalTheme"
    [submitButton]="false"
    [cancelButton]="false"
    (modalCancel)="onModalCancel($event)">
    <pre class="text-break m-0 prewrap" [textContent]="info"></pre>
</modal-hoc>
